import { useCallback } from "react";

import { Callout } from "../components";
import { Col1 } from "../lib";
import { createStyles } from "../theme";

export function ErrorScreen() {
  // Methods
  const goToHome = useCallback(() => {
    // TODO: web only for now
    document.location = "/";
  }, []);

  // Render
  return (
    <Col1 style={$.container}>
      <Callout
        icon="alert-circle-outline"
        title="Oops! Something went wrong"
        message="Looks like we hit a snag. Please reload the app to continue."
        action="Reload app"
        onPress={goToHome}
      />
    </Col1>
  );
}

const $ = createStyles({
  container: {
    backgroundColor: "background",
  },
});
